<bb-tabs></bb-tabs>
<router-outlet></router-outlet>
